import React, { useEffect } from 'react'
import Footer from '../../components/Footer'
import HomeVideo from '../../components/HomeVideo'
import WhyChooseUs from '../../components/WhyChooseUs'
import NewHome from '../../components/NewHome';
import HomeImage from '../../components/HomeImage'
import ScrollToTop from '../../components/ScrollToTop'
export default function Home() {

    useEffect(() => {
        document.title = 'MinMin Wedding - Phóng Sự Cưới';
    }, []);
    return (
        <>

            <ScrollToTop />

            <div >
                <NewHome />
            </div>
            <div style={{ marginTop: '5px' }}>
                <HomeVideo />
            </div>
            <div >
                <HomeImage />
            </div>
            <div>
                <WhyChooseUs />
            </div>
            <div style={{ marginTop: '5px' }}>

                <Footer />
            </div>
        </>
    )
}